import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { getRequisites, postRequisites } from '../../../../../crud/docs.crud';
import { getResponseMessage } from '../../../../../utils/utils';

type DataRequisites = {
  requisites: {
    inn: string;
    kpp: string;
    ogrn: string;
    legal_address: string;
    post_address: string;
    payment_account: string;
    bank: string;
    bank_bic: string;
    correspondent_account: string;
    owner: string;
    legal_entity: string;
  };
};

export const useRequisites = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [requisites, setRequisites] = useState<DataRequisites | null>(null);
  const fetchRequisites = useCallback(async () => {
    if (loading) return;
    setLoading(true);
    getRequisites()
      .then((res: any) => {
        setRequisites(res.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const editRequisites = useCallback(async (data: DataRequisites) => {
    setEditLoading(true);

    postRequisites(data)
      .then(() => {
        enqueueSnackbar(intl.formatMessage({ id: 'TITLE.SAVED' }), {
          variant: 'success',
        });
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setEditLoading(false);
      });
  }, []);
  return { fetchRequisites, loading, requisites, editLoading, editRequisites };
};
